import type { MqttClient, OnMessageCallback } from 'mqtt';
import {getNodeUUid} from './util'
export default class ServerMQTT {
    username: string;
    password: string;
    clean: boolean;
    connectTimeout: number;
    url: string; // mqtt地址
    topic: string; //订阅地址
    pubTopic: string; //发布地址
    client!: MqttClient;
    constructor(url:string,username: string,password:string,topic:string,pubTopic:string) {
        this.clean = true,
        this.password = password,
        this.username = username,
        this.connectTimeout = 4000, // 超时时间
        this.topic = topic;
        this.pubTopic = pubTopic
        // 虽然是mqtt但是在客户端这里必须采用websock的链接方式
        this.url = url;
    }

    init(receiveMessage: OnMessageCallback) {
        const mqtt=(window as any).mqtt;
        if(!mqtt){
            console.warn('<script src="https://unpkg.com/mqtt/dist/mqtt.min.js"></script>');
            return;
        }
        const options = {
            clean: this.clean,
            clientId: getNodeUUid(),
            password: this.password,
            username: this.username,
            connectTimeout: this.connectTimeout, // 超时时间
        };
        this.client = mqtt.connect(this.url, options);
        this.client.on('error', (error: any) => {
            console.error("连接错误:",error)
        });
        this.client.on('reconnect', () => {
            console.warn("连接错误尝试重连，请检查配置，账号密码是否正确，如果不想使用请重置")
        });
        this.client.on('connect', () => {
            const that = this
            //连接成功订阅消息
            this.client.subscribe(this.topic, (error: any) => {
                if (!error) {
                    console.info('订阅成功');
                    that.client.publish(that.pubTopic, 'Hello mqtt')
                } else {
                    console.info('订阅失败');
                }
            });
            console.info("连接成功")
        });
        this.client.on('message', receiveMessage);
    };
    send(data:any) {
        this.client.publish(this.pubTopic,data)
    }
    close(){
        this.client.end();
    }
}
